import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <>
      <div className="container">
        <div className="badge">Error</div>

        <h1>
          404
        </h1>

        <p className="subtitle">
          The page you are looking for does not exist.
        </p>

        <Link to="/" className="button">
            Go to Home
        </Link>
      </div>

      <footer>
        &copy; 2023 The Tech Collective. All rights reserved.
      </footer>
    </>
  );
};

export default NotFoundPage;
